import { SharedConstants } from "../../shared/constants/shared.constants";
export class CreateApplicationConstants {
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static CONTINUE_BUTTON_PLACEHOLDER = SharedConstants.CONTINUE_STEP_TEXT;
    static BACK_BUTTON_PLACEHOLDER = SharedConstants.BACK_STEP_TEXT;
    static CREATE_BUTTON_PLACEHOLDER = "Create application";
    static CLEAR_BUTTON_PLACEHOLDER = SharedConstants.CLEAR_LABEL;
    static SUBMIT_BUTTON_PLACEHOLDER = SharedConstants.SUBMIT_LABEL;
    static CLOSE_BUTTON_PLACEHOLDER = SharedConstants.CLOSE_LABEL;
    static CONTENT_PAGE_HEADING = "Create application";
    static NAME_INPUT_LABEL = "Name";
    static SURNAME_INPUT_LABEL = "Surname";
    static CREATE_APPLICATION_LABEL = "Create";
    static ERF_INPUT_LABEL = "Erf";
    static ADDRESS_INPUT_LABEL = "Address";
    // Create application Steps
    static WELCOME_HEADING = "Welcome to the";
    static WELCOME_HEADING_APPLICATION = "application";
    static VIEW_DOCUMENTS_LINK_TEXT = "HERE";
    static APPLICATIONS = "applications";
    static PLEASE_CLICK_TEXT = "Please click";
    static MORE_INFO_TEXT = "for more information related to";
    static DETAILS_HEADING = "Application Details";
    static LOCATION_HEADING = "Location";
    static PROFESSIONAL_BODIES_HEADING = "Professional bodies";
    static DECEASED_HEADING = "Deceased";
    static FAMILY_HEADING = "Family";
    static APPLICANT_HEADING = "Applicant details";
    static APPLICANT_AGENT_HEADING = "Applicant agent details";
    static REQUIRED_DOCUMENTATION_HEADING = "Required documentation";
    // TODO: replace with configurable text
    static WELCOME_MESSAGE = "Please configure this text.\n";
}
